import ReactDOM from 'react-dom';
import React, { PureComponent } from 'react';
import { Icon } from 'antd-mobile';
import './index.less';

let popupQueue = [];

class Explain extends PureComponent {
  static defaultProps = {
    conditions: [],
  };

  constructor(props) {
    super(props);
    const { conditions } = this.props;
    this.state = {
      arr: conditions,
      showTextIndex: 0,
      hidden: true,
    };
  }
  //点击展开、关闭规则文字
  showRlues(e, index) {
    e.stopPropagation();
    this.setState({ showTextIndex: index });
  }

  render() {
    const { onClose, lang } = this.props;
    const { arr, showTextIndex } = this.state;
    let isShowText = [];
    arr.map((obj, index) => {
      if (index === showTextIndex) {
        return isShowText.push(true);
      } else {
        return isShowText.push(false);
      }
    });
    return (
      <div
        className="explain_main_bg"
        role="button"
        aria-label="关闭"
        onClick={onClose}
      >
        <div className="max_heght_box">
          {arr.map((obj, index) => {
            return (
              <div
                className="rules_content changebg_color"
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {arr.length > 1 ? (
                  <div
                    className="border"
                    role="button"
                    onClick={e => this.showRlues(e, index)}
                  >
                    <div className="flight_title">
                      <i />
                      {obj.flightNo}&nbsp;<span>|</span>&nbsp;{obj.flightClass}
                    </div>
                    <ul>
                      <li className="voyage">
                        <p>{obj.depTime}</p>
                        <span>{obj.depAirportName}</span>
                      </li>
                      <li className="arrows">
                        <span />
                        <div className="triangle_border_right" />
                      </li>
                      <li className="voyage">
                        <p>{obj.arrTime}</p>
                        <span>{obj.arrAirportName}</span>
                      </li>
                    </ul>
                    <a className="text_btn">{isShowText[index] ? '∧' : '∨'}</a>
                  </div>
                ) : null}
                <div
                  className="showRules_text"
                  style={{ display: isShowText[index] ? 'block' : 'none' }}
                >
                  <div className="rules_title">
                    <span />
                    {lang.TermsOfUse}
                  </div>
                  <div className="description_rules">
                    <div className="rules1">{obj.adultInstructions}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

class ExplainRules extends PureComponent {
  static defaultProps = {
    conditions: [],
  };

  constructor(props) {
    super(props);
    const { conditions } = this.props;
    this.state = {
      arr: conditions,
      index: 0,
      hidden: true,
    };
  }
  //点击展开、关闭规则文字
  showRlues(e, index) {
    e.stopPropagation();
    this.setState({ showTextIndex: index });
  }

  _handleClickLeft = e => {
    e.preventDefault();
    e.stopPropagation();
    const { index } = this.state;
    if (index === 0) {
      return false;
    }
    this.setState({
      index: index - 1,
    });
  };

  _handleClickRight = e => {
    e.preventDefault();
    e.stopPropagation();
    const { index } = this.state;
    if (index + 1 === this.props.conditions.length) {
      return false;
    }
    this.setState({
      index: index + 1,
    });
  };

  render() {
    const { onClose, conditions, lang } = this.props;
    const { index } = this.state;
    const obj = conditions[index];
    const {
      beforeChange,
      afterChange,
      beforeRefund,
      afterRefund,
    } = obj.segmentlabletext.changeRefundRule;
    return (
      <div className="explain explain__layoutCenter" onClick={onClose}>
        <div className="explain__content">
          <div className="explain__top">
            <div>
              <Icon type="left" onClick={this._handleClickLeft} />
            </div>
            <div className="explain__flightInfo">
              <div>{`${obj.flightNo} | ${obj.flightDate}`}</div>
              <div className="flight">
                <div className="dep">
                  <div>{obj.depTime}</div>
                  <div>{obj.depCityName}</div>
                </div>
                <div className="arrows">
                  <span />
                  <div className="triangle_border_right" />
                </div>
                <div className="arrive">
                  <div>{obj.arrTime}</div>
                  <div>{obj.arrCityName}</div>
                </div>
              </div>
            </div>
            <div>
              <Icon type="right" onClick={this._handleClickRight} />
            </div>
          </div>
          <div className="explain__bottom">
            <div>{lang.rfInstruction}</div>
            <div className="explain__table">
              <table cellspacing="0" cellpadding="0">
                <tr>
                  <th />
                  <th>{lang.unused}</th>
                  <th>{lang.partiallyUsed}</th>
                </tr>
                <tr>
                  <td>{lang.updateDetail56}</td>
                  <td>{beforeChange === 'N' ? lang.noChange : beforeChange}</td>
                  <td>{afterChange === 'N' ? lang.noChange : afterChange}</td>
                </tr>
                <tr>
                  <td>{lang.updateDetail57}</td>
                  <td>{beforeRefund === 'N' ? lang.noRefund : beforeRefund}</td>
                  <td>{afterRefund === 'N' ? lang.noRefund : afterRefund}</td>
                </tr>
              </table>
            </div>
            <div>{lang.referenceTip}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default function explainBox(...args) {
  const data = args[0];
  const isBrandFreight = args[1] || false;

  let div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    if (!div) return;
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    div = null;
  }

  if (!isBrandFreight) {
    ReactDOM.render(
      <Explain
        conditions={data}
        onClose={() => {
          close();
        }}
      />,
      div
    );
  } else {
    ReactDOM.render(
      <ExplainRules
        conditions={data}
        onClose={() => {
          close();
        }}
      />,
      div
    );
  }

  popupQueue.push({
    close,
  });

  return popupQueue[popupQueue.length - 1];
}

explainBox.clear = () => {
  if (popupQueue && popupQueue.length) {
    popupQueue.forEach(progess => {
      progess.close();
    });
    popupQueue = [];
  }
};



// WEBPACK FOOTER //
// ./src/routes/routes/applySubmit/components/Explain/index.js